<template>
  <el-row id="calendar" style="height: 100%">
    <navBar :tags="tags" :title="titleName" :subTitle="subTitle" :btnAdd="false" :btnBack="false" @btnAdd="handleAdd" @btnBackClick="handleBackClick" />
    <el-row id="calendar_body_row_p" style="height: calc(100% - 85px)">
      <el-col :span="24" style="margin-top: 0px;height: 100%;">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClickTabs" style="margin: auto;height: 100%;">
          <el-tab-pane label="日" name="日" style="font-size: 18px;font-weight: bold;height: 100%;">
            <el-row style="display: flex;">
              <el-col>
                <el-button icon="el-icon-download" type="primary" style="margin-left: 20px;" @click="getCalendarInstantData()">即时数据</el-button>
              </el-col>
              <el-col style="text-align: center;margin-right: 400px;">
                <span style="font-size: 28px;color: #646464;text-align: center;">{{ thisMonth }}</span>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px;height:20px">
              <el-col style="text-align: center;position: relative">
                <div v-if="btnOff">
                  <span style="position:absolute;left:20px;font-size: 14px;color: #F5A623;" v-if="mapOff">
                    <img src="../../../assets/images/schedule_map.png" style="vertical-align: middle;width: 20px;height: 20px;" />
                    <span @click="switchMap" style="cursor: pointer">切换地图模式</span>
                  </span>
                  <span style="position:absolute;left:20px;font-size: 14px;color: #F5A623;" v-else>
                    <img src="../../../assets/images/schedule_list.png" style="vertical-align: middle;width: 20px;height: 20px;" />
                    <span @click="switchMap" style="cursor: pointer">切换列表模式</span>
                  </span>
                </div>

                <span
                  v-if="isShowWeekPlan()"
                  style="font-size: 14px;
                                        color:#909399;display: inline-block;height: 18px;
                                        cursor:pointer"
                  @click="openModel"
                  >周计划完成度 </span
                ><span
                  v-if="isShowWeekPlan()"
                  @click="openModel"
                  style="display: inline-block;padding: 2px 4px;
                                        color:white;cursor: pointer;
                                    background:#fc9701;font-size: 12px;border-radius: 2px;margin-left: 5px"
                  >{{ completeDegree }}</span
                >

                <div style="position: absolute;right: 20px;top: -10px;z-index: 999" v-if="this.role != 'staff'">
                  <span style="font-weight: bold;margin-right: 10px">人员</span>
                  <el-select
                    v-if="title !== '管理员'"
                    v-model="selectPeople"
                    clearable
                    v-on:change="handleSelectInputClick"
                    :disabled="title !== '管理员'"
                    placeholder=""
                    style="width: 160px"
                  >
                    <el-option v-for="(item, index) in options" :key="item.user_id" :label="item.user_name" :value="item.user_id"> </el-option>
                  </el-select>
                  <inputSelect :handleSelectInput="handleSelectInputClick" :key="timer" v-if="title === '管理员' && onoffSelect"></inputSelect>
                </div>
              </el-col>
            </el-row>
            <!-- hello -->
            <el-row style="padding: 0px 20px;height: calc(100% - 60px)">
              <el-col style="width: 400px;padding-right: 20px;margin-top: 15px">
                <el-calendar :first-day-of-week="7" v-model="calendarDate"> </el-calendar>
              </el-col>
              <el-col style="width: calc(100% - 400px) ;border: 1px solid #DCDFE6;margin-top: 15px;height: calc(100% - 15px)">
                <el-row>
                  <el-col v-if="onoffTotalColor()" style="border-bottom: 1px solid #DCDFE6;height: 40px;text-align: center;line-height: 40px;font-size: 18px">
                    <span>{{ thisDay }} </span>

                    <span
                      style="display: inline-block;width: 30px;height: 30px;
                                                        background:  #EB503C;
                                                line-height: 30px;
                                                color:white;border-radius:50%"
                    >
                      {{ thisDayStr }}</span
                    >
                    <span>日</span>
                    <span v-text="weekTextWeek(thisDayWeek)"></span>
                  </el-col>
                  <el-col v-else style="border-bottom: 1px solid #DCDFE6;height: 40px;text-align: center;line-height: 40px;font-size: 18px">
                    <span>{{ thisDay }} {{ thisDayStr }} </span>

                    <span>日</span>
                    <span v-text="weekTextWeek(thisDayWeek)"></span>
                  </el-col>
                </el-row>
                <el-row v-if="mapOff" style="height: calc(100% - 40px);overflow: hidden;overflow-y: auto;">
                  <el-col v-for="(item, index) in dayArray" :key="index" id="calendarColDay" @click.native="getlclickInfoRouter(item, thisDate)" style="margin-top: 10px;">
                    <div style="float: left;width: 30%;text-align: center;margin-top: 12px;">
                      <span style="display: inline-block;width: 70px;">{{ item.time }}</span>
                      <img style="" :src="item.img" alt="" style="vertical-align: middle" />
                    </div>
                    <div style="float: left;font-size: 12px;width: 58%">
                      <p style="font-size: 16px">{{ item.institution_name }}</p>
                      <p style="color: #bbbbbb" v-html="item.address"></p>
                      <p style="color: #409EFF;" v-html="item.textValue1"></p>
                      <p style="color: #409EFF;">{{ item.num }}</p>
                      <p style="color: #409EFF;" v-html="item.textCreateBy"></p>
                      <p style="">
                        <span
                          v-for="(hcp_dept, j) in item.hcp_deptList"
                          style="margin-top: 5px;
                                                        display: inline-block;padding: 6px;background: #FF9901;color: white;border-radius: 3px;margin-right: 4px"
                        >
                          {{ hcp_dept.dept_name + "-" + hcp_dept.hcp_name }}</span
                        >
                      </p>
                      <p style="">
                        <span
                          v-for="(contact_list, j) in item.contactList"
                          style="margin-top: 5px;
                                                        display: inline-block;padding: 6px;background: #FF9901;color: white;border-radius: 3px;margin-right: 4px"
                        >
                          {{ contact_list.contact_name }}</span
                        >
                      </p>
                      <p style="">
                        <span
                          v-for="(cust_list, j) in item.customer_List"
                          style="margin-top: 5px;
                                                        display: inline-block;padding: 6px;background: #FF9901;color: white;border-radius: 3px;margin-right: 4px"
                        >
                          {{ cust_list.name }}</span
                        >
                      </p>
                      <p v-for="(obj, j) in item.checkinArray" style="">
                        <span style="color: #F5A623;">{{ obj.str }}</span
                        ><span style="margin-left: 10px" :style="{ color: obj.str2 === '  尚未签出' ? 'red' : '#F5A623' }"> {{ obj.str2 }}</span>
                      </p>
                    </div>
                    <div style="float: left;width: 10%">
                      <i
                        class="el-icon-arrow-right"
                        style="line-height: 50px;
                                                            color: #bbbbbb"
                      ></i>
                    </div>
                  </el-col>
                </el-row>
                <div :style="{ width: '100%' }" v-else style="height: calc(100% - 40px);overflow: hidden;overflow-y: auto;position: relative;">
                  <el-amap vid="amap" :plugin="plugin" class="amap-demo" :center="center" :zoom="zoom" :amapManager="amapManager">
                    <el-amap-marker :position="marker.position" :template="marker.template" v-for="marker in centers" :events="marker.events" :visible="marker.visible">
                    </el-amap-marker>
                  </el-amap>
                  <div align="center" style="position: absolute;top:50px;left:calc(50% - 65px)">
                    <span
                      style="position: relative;
                    top: -35px;
                    background-color: #b6bbbf;
                    border: 1px solid #ccc;
                    color: #fff;
                    font-size: 14px;
                    border-radius: 5px;
                    padding: 2px 5px;
                    "
                      >当日总行程：{{ tolls_distance }}公里</span
                    >
                  </div>
                  <div class="swiper-container" ref="swiperContainer" style="position: absolute;bottom: 0;z-index:999;padding: 20px;width: calc(100% - 40px);height: auto;">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide" v-for="(item, j) in mapArray" style="width: auto">
                        <div
                          v-if="item.category == 'MEETING'"
                          @click="mapArrayClick(item)"
                          style="width: 300px;background: #fff;margin-right: 20px;"
                          :style="{ border: item.selected ? '1px solid #4A90E2' : '1px solid #fff', backgroundColor: item.selected ? '#ecf3fc' : '#fff' }"
                        >
                          <el-row style="width: 100%;height: 50px;padding:12px 5px 5px;">
                            <el-col :span="4">
                              <div
                                style="background: #9b9b9b;width: 25px;height: 25px;text-align: center;line-height:25px;font-size: 12px;color: #fff;border-radius:50%;margin-left: 10px"
                              >
                                {{ j + 1 }}
                              </div>
                            </el-col>
                            <el-col :span="16">
                              <p style="font-size: 15px;color: #4D586D;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{ item.title }}</p>
                              <p style="font-size: 12px;color: #B0B5B9;margin:0;line-height: 20px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                                {{ item.address }}
                              </p>
                            </el-col>
                            <el-col :span="4">
                              <img style="" :src="item.img" alt="" style="vertical-align: middle;width: 25px;height: 25px;margin-left: 10px" />
                            </el-col>
                          </el-row>
                          <el-row style="width: 100%;height: 50px;padding:5px 5px 5px;">
                            <el-col :span="4">
                              <div style="width: 1px;height: 1px;"></div>
                            </el-col>
                            <el-col :span="20">
                              <p style="font-size: 12px;color: #4A90E2;margin:0;line-height: 20px;">{{ item.num }}</p>
                              <p style="font-size: 12px;color: #4A90E2;margin:0;line-height: 20px;">{{ item.textCreateBy }}</p>
                            </el-col>
                          </el-row>
                        </div>
                        <div
                          v-if="item.category == 'HCP_CALL'"
                          @click="mapArrayClick(item)"
                          style="width: 300px;background: #fff;margin-right: 20px;"
                          :style="{ border: item.selected ? '1px solid #4A90E2' : '1px solid #fff', backgroundColor: item.selected ? '#ecf3fc' : '#fff' }"
                        >
                          <el-row style="width: 100%;height: 50px;padding:12px 5px 5px;">
                            <el-col :span="4">
                              <div
                                style="background: #9b9b9b;width: 25px;height: 25px;text-align: center;line-height:25px;font-size: 12px;color: #fff;border-radius:50%;margin-left: 10px"
                              >
                                {{ j + 1 }}
                              </div>
                            </el-col>
                            <el-col :span="16">
                              <p style="font-size: 15px;color: #4D586D;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{ item.title }}</p>
                              <p style="font-size: 12px;color: #B0B5B9;margin:0;line-height: 20px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                                {{ item.address }}
                              </p>
                            </el-col>
                            <el-col :span="4">
                              <img style="" :src="item.img" alt="" style="vertical-align: middle;width: 25px;height: 25px;margin-left: 10px" />
                            </el-col>
                          </el-row>
                          <el-row style="width: 100%;min-height: 50px;padding:5px 5px 5px;">
                            <el-col :span="4">
                              <div style="width: 1px;height: 1px;"></div>
                            </el-col>
                            <el-col :span="20">
                              <p style="font-size: 12px;color: #4A90E2;margin:0;line-height: 20px;">{{ item.text }}</p>
                              <p v-for="(obj, j) in item.checkinArray" style="margin:0;font-size: 12px;line-height: 20px;">
                                <span style="color: #F5A623;">{{ obj.str }}</span
                                ><span style="margin-left: 10px" :style="{ color: obj.str2 === '  尚未签出' ? 'red' : '#F5A623' }"> {{ obj.str2 }}</span>
                              </p>
                            </el-col>
                          </el-row>
                        </div>
                        <div
                          v-if="item.category == 'STORE_INSPECTION'"
                          @click="mapArrayClick(item)"
                          style="width: 300px;background: #fff;margin-right: 20px;"
                          :style="{ border: item.selected ? '1px solid #4A90E2' : '1px solid #fff', backgroundColor: item.selected ? '#ecf3fc' : '#fff' }"
                        >
                          <el-row style="width: 100%;height: 50px;padding:12px 5px 5px;">
                            <el-col :span="4">
                              <div
                                style="background: #9b9b9b;width: 25px;height: 25px;text-align: center;line-height:25px;font-size: 12px;color: #fff;border-radius:50%;margin-left: 10px"
                              >
                                {{ j + 1 }}
                              </div>
                            </el-col>
                            <el-col :span="16">
                              <p style="font-size: 15px;color: #4D586D;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{ item.title }}</p>
                              <p style="font-size: 12px;color: #B0B5B9;margin:0;line-height: 20px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                                {{ item.address }}
                              </p>
                            </el-col>
                            <el-col :span="4">
                              <img style="" :src="item.img" alt="" style="vertical-align: middle;width: 25px;height: 25px;margin-left: 10px" />
                            </el-col>
                          </el-row>
                          <el-row style="width: 100%;min-height: 50px;padding:5px 5px 5px;">
                            <el-col :span="4">
                              <div style="width: 1px;height: 1px;"></div>
                            </el-col>
                            <el-col :span="20">
                              <p v-for="(obj, j) in item.checkinArray" style="margin:0;font-size: 12px;line-height: 20px;">
                                <span style="color: #F5A623;">{{ obj.str }}</span
                                ><span style="margin-left: 10px" :style="{ color: obj.str2 === '  尚未签出' ? 'red' : '#F5A623' }"> {{ obj.str2 }}</span>
                              </p>
                            </el-col>
                          </el-row>
                        </div>
                        <div
                          v-if="item.category == 'DISTRIBUTOR'"
                          @click="mapArrayClick(item)"
                          style="width: 300px;height: 100px;background: #fff;margin-right: 20px;"
                          :style="{ border: item.selected ? '1px solid #4A90E2' : '1px solid #fff', backgroundColor: item.selected ? '#ecf3fc' : '#fff' }"
                        >
                          <el-row style="width: 100%;height: 50%;padding:12px 5px 5px;">
                            <el-col :span="4">
                              <div
                                style="background: #9b9b9b;width: 25px;height: 25px;text-align: center;line-height:25px;font-size: 12px;color: #fff;border-radius:50%;margin-left: 10px"
                              >
                                {{ j + 1 }}
                              </div>
                            </el-col>
                            <el-col :span="16">
                              <p style="font-size: 15px;color: #4D586D;margin:0;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{ item.title }}</p>
                              <p style="font-size: 12px;color: #B0B5B9;margin:0;line-height: 20px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                                {{ item.address }}
                              </p>
                            </el-col>
                            <el-col :span="4">
                              <img style="" :src="item.img" alt="" style="vertical-align: middle;width: 25px;height: 25px;margin-left: 10px" />
                            </el-col>
                          </el-row>
                          <el-row style="width: 100%;height: 50%;padding:5px 5px 5px;">
                            <el-col :span="4">
                              <div style="width: 1px;height: 1px;"></div>
                            </el-col>
                            <el-col :span="20">
                              <p style="font-size: 12px;color: #4A90E2;margin:0;line-height: 20px;">{{ item.textValue1 }}</p>
                            </el-col>
                          </el-row>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>

          <el-tab-pane label="周" name="周" style="height: 100%;">
            <el-row>
              <el-col style="text-align: center">
                <span style="font-size: 28px;color: #646464;text-align: center;">{{ thisMonth }}</span>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px;height: calc(100% - 38px)">
              <el-col style="text-align: center;height: 100%;">
                <el-row style="padding: 0px 20px">
                  <el-col :span="8" style="position: relative;top: 5px;">
                    <div align="left" id="check">
                      <el-button-group :class="$style.month" class="a_modal">
                        <el-button size="small" icon="el-icon-arrow-left" style="padding: 9px" @click.stop="lastNextMonthClick(-1)"></el-button>
                        <el-button size="small" style="padding: 9px" disabled>{{ dateWeekStr }}</el-button>
                        <el-button size="small" icon="el-icon-arrow-right" style="padding: 9px" @click.stop="lastNextMonthClick(1)"></el-button>
                      </el-button-group>
                    </div>
                  </el-col>

                  <el-col :span="8">
                    <div align="center">
                      <span
                        v-if="isShowWeekPlan()"
                        style="font-size: 14px;cursor: pointer;
                                                          color:#909399;display: inline-block;height: 18px;  "
                        @click="openModel"
                        >周计划完成度 </span
                      ><span
                        v-if="isShowWeekPlan()"
                        @click="openModel"
                        style="display: inline-block;padding: 2px 4px;
                                        color:white;cursor: pointer;
                                        background:#fc9701;font-size: 12px;border-radius: 2px;margin-left: 5px"
                      >
                        {{ completeDegree }}</span
                      >
                      <section style="margin-top: 5px">
                        <!--                                            <span :style="{'color':getStatusBackground(tabStatus)}">{{tabStatusStr}}</span>-->
                      </section>
                    </div>
                  </el-col>

                  <el-col :span="8" style="position: relative" @click="openModel" v-if="this.role != 'staff'">
                    <div align="right" style="right: 0;position: absolute">
                      <span style="font-weight: bold;margin-right: 10px">人员</span>
                      <el-select
                        v-if="title !== '管理员'"
                        v-model="selectPeople"
                        clearable
                        v-on:change="handleSelectInputClick"
                        :disabled="title !== '管理员'"
                        placeholder=""
                        style="width: 160px"
                      >
                        <el-option v-for="(item, index) in options" :key="item.user_id" :label="item.user_name" :value="item.user_id"> </el-option>
                      </el-select>
                      <inputSelect :handleSelectInput="handleSelectInputClick" :key="timer" v-if="title === '管理员' && onoffSelect"></inputSelect>
                    </div>
                  </el-col>
                </el-row>
                <el-row style="height:calc(100% - 97px);padding:0 20px;margin-top: 10px">
                  <el-col style="height: 100%;overflow: hidden;position: relative">
                    <div style="width: 100%;height: 100%;transition: .3s;">
                      <ul
                        class="ulScoller"
                        :style="{ left: marginValue }"
                        style="width: 100%;height: 100%;
                                                        transition: .3s;
                                                        position: relative;

                                                "
                      >
                        <li
                          class="weekLi"
                          v-for="(obj, j) in arrayMonth"
                          :key="j"
                          style="position: absolute;width: 20%;height: 100%;

                                                    float: left;box-sizing: border-box;
                                                    "
                        >
                          <p
                            style="width: 100%;height:30px;
                                                        border-bottom: 1px solid #DCDFE6;
                                                        font-size: 16px;margin: 0;
                                                        line-height:30px"
                          >
                            {{ weekText(j) }}
                          </p>
                          <div style="width: 100%;height: calc(100% - 31px);overflow: auto">
                            <div
                              style="width: 100%;overflow: hidden;margin-top: 10px;
                                                                        margin-bottom:10px;cursor: pointer;"
                              v-for="(item, index) in obj"
                              @click="getlclickInfoRouter(item, 'week')"
                              :key="index"
                            >
                              <div style="float: left;width: 30%;margin-top: 2px">
                                <p style="font-size: 12px;">{{ item.time }}</p>
                                <img style="" :src="item.img" alt="" />
                              </div>
                              <div style="float: left;width: 60%;font-size: 12px;text-align: left">
                                <p style="font-size: 14px;line-height: 18px">{{ item.institution_name }}</p>
                                <p style="color: #bbbbbb;line-height: 16px" v-html="item.address"></p>
                                <p style="color: #409EFF;line-height: 16px" v-html="item.textValue1"></p>
                                <p style="color: #409EFF;line-height: 16px">{{ item.text }}{{ item.num }}</p>
                                <p style="color: #409EFF;line-height: 16px" v-html="item.textCreateBy"></p>
                                <p v-for="(objItem, j) in item.checkinArray" style="line-height: 16px">
                                  <span style="color: #F5A623;">{{ objItem.str }}</span
                                  ><span style="margin-left: 10px;line-height: 16px" :style="{ color: objItem.str2 === '  尚未签出' ? 'red' : '#F5A623' }">
                                    {{ objItem.str2 }}</span
                                  >
                                </p>
                              </div>
                              <div style="float: left;width: 10%">
                                <i
                                  class="el-icon-arrow-right"
                                  style="line-height: 50px;
                                                                color: #bbbbbb"
                                ></i>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
                <el-row style="margin-top: 20px;padding:0 20px 15px">
                  <el-col :span="12" style="text-align: left;height: 20px;position: relative">
                    <img style="cursor: pointer" :src="left_png" alt="" @click="weekLiMarginLeft()" />
                    <span
                      @click="weekLiMarginLeft()"
                      style="color: #F5A623;cursor: pointer;display: inline-block;position: absolute;
                                                      left: 25px;top: 1px;
                                                     width: 70px;"
                    >
                      {{ weekLiMargin_text_left }}</span
                    >
                  </el-col>
                  <el-col :span="12" style="text-align: right;height: 20px;position: relative">
                    <span
                      @click="weekLiMarginRight()"
                      style="color: #F5A623;cursor: pointer;display: inline-block;position: absolute;
                                                       right: 25px;top: 1px;
                                                      width: 70px "
                      >{{ weekLiMargin_text_right }}
                    </span>
                    <img style="cursor: pointer" :src="right_png" alt="" @click="weekLiMarginRight()" />
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>

          <el-tab-pane label="月" name="月" style="height: 100%;">
            <el-row style="padding: 0px 20px">
              <el-col :span="8" style="position: relative;top:5px">
                <div align="left">
                  <el-button-group :class="$style.month" class="a_modal">
                    <el-button size="small" icon="el-icon-arrow-left" style="padding: 9px" @click.stop="lastNextMonthClickMonth(-1)"></el-button>
                    <el-button size="small" disabled>{{ dateMonthStr }}</el-button>
                    <el-button size="small" icon="el-icon-arrow-right" style="padding: 9px" @click.stop="lastNextMonthClickMonth(1)"></el-button>
                  </el-button-group>
                </div>
              </el-col>

              <el-col :span="8">
                <div align="center">
                  <span style="font-size: 28px;color: #646464">{{ dateMonthStr }}</span>
                  <!--                                    <section style="margin-top: 5px">-->
                  <!--                                        <span :style="{'color':getStatusBackground(tabStatus)}">{{tabStatusStr}}</span>-->
                  <!--                                    </section>-->
                </div>
              </el-col>

              <el-col :span="8" style="position: relative" v-if="this.role != 'staff'">
                <div align="right" style="right: 0;position: absolute;">
                  <span style="font-weight: bold;margin-right: 10px">人员</span>
                  <el-select
                    v-if="title !== '管理员'"
                    v-model="selectPeopleMonth"
                    v-on:change="handleSelectInputClick"
                    :disabled="title !== '管理员'"
                    placeholder=""
                    style="width: 160px"
                  >
                    <el-option v-for="(item, index) in options" :key="item.user_id" :label="item.user_name" :value="item.user_id"> </el-option>
                  </el-select>
                  <inputSelect :handleSelectInput="handleSelectInputClick" :key="timer" v-if="title === '管理员' && onoffSelect"></inputSelect>
                </div>
              </el-col>
            </el-row>
            <el-row style="padding: 10px 20px 0px;height: calc(100% - 38px)">
              <el-col style="height: 100%;">
                <div class="calendar" style="height: calc(100% - 45px);overflow: hidden;overflow-y: auto;">
                  <table class="sign_tab" border="0px" cellpadding="0px" cellspacing="0px">
                    <thead>
                      <tr style="background: #F2F6F9;">
                        <td style="font-weight: bold;width: 14%;">周日</td>
                        <td style="font-weight: bold;width: 14%;">周一</td>
                        <td style="font-weight: bold;width: 14%;">周二</td>
                        <td style="font-weight: bold;width: 14%;">周三</td>
                        <td style="font-weight: bold;width: 14%;">周四</td>
                        <td style="font-weight: bold;width: 14%;">周五</td>
                        <td style="font-weight: bold;width: 14%;">周六</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, j) in dateArr" :key="j" v-if="contains(item)">
                        <template v-for="dataObj in item">
                          <td :class="{ disa: monthClass(dataObj.month), other: !monthClass(dataObj.month) }" @dblclick="getdblclickInfo(dataObj.arr, dataObj.date)">
                            <span :class="{ styleNowDate: monthColor(dataObj.date) }" style="position:absolute;right:10px;top:10px;width: 15px;height: 15px;font-weight: bold">{{
                              dataObj.date | getCD
                            }}</span>

                            <section>
                              <div style="padding: 1px 5px;text-align: left;margin-top: 10px">
                                <p :class="$style.span_shift_s" :style="{ background: getBackground() }" style="font-size: 12px;color: #4A90E2;line-height: 16px">
                                  {{ dataObj.institutionNum }}
                                </p>
                              </div>
                              <div style="padding: 0px 5px;text-align: left">
                                <p v-for="(item, i) in dataObj.eventText" :key="i" style="font-size: 12px;color: #FF6F61;line-height: 16px" v-if="dataObj.eventText">{{ item }}</p>
                              </div>
                              <div style="padding: 0px 5px;text-align: left">
                                <p v-for="(item, i_1) in dataObj.travel" :key="i_1" style="font-size: 12px;color: #C8ABED;line-height: 16px" v-if="dataObj.travel">{{ item }}</p>
                              </div>
                              <div style="padding: 0px 5px;text-align: left">
                                <p
                                  v-for="(item, i_2) in dataObj.internal"
                                  :key="i_2"
                                  style="font-size: 12px;
                                                                      color:#1F8450;line-height: 16px"
                                  v-if="dataObj.internal"
                                >
                                  {{ item }}
                                </p>
                              </div>
                              <div style="padding: 0px 5px;text-align: left">
                                <p
                                  v-for="(item, i_3) in dataObj.coaching"
                                  :key="i_3"
                                  style="font-size: 12px;
                                                                      color:#5B5FDD;line-height: 16px"
                                  v-if="dataObj.coaching"
                                >
                                  {{ item }}
                                </p>
                              </div>
                              <div style="padding: 0px 5px;text-align: left">
                                <p
                                  style="font-size: 12px;
                                                                      color:#6BC235;line-height: 16px"
                                  v-if="dataObj.disListNum"
                                >
                                  {{ dataObj.disListNum }}
                                </p>
                              </div>
                            </section>
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="channel" align="center" style="margin-bottom: 20px">
                  <span>
                    在某个日期格子中双击可查看当天日程安排
                  </span>
                  <section style="margin-top: 5px" class="ware">
                    <!--                                        <div v-for="(item, index) in shiftBArray" :key="index" :label="item" :span="8">-->
                    <!--                                            <div style="padding: 5px" v-if="item.shift_id">-->
                    <!--                                                <span :class="$style.span_shift" :style="{'background':getBackground(item.icon_color)}">{{item.icon_text}}</span>-->
                    <!--                                                <section style="margin-top: 5px">-->
                    <!--                                                    <span>{{item.start_time}}-{{item.end_time}}</span>-->
                    <!--                                                </section>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                  </section>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>

      <el-dialog title="" :visible.sync="dialogVisible" :show-close="false" :before-close="handleClose" id="calendar_weekPlanInfo_dialog">
        <div
          slot="title"
          class="dialog-footer"
          style="display: flex;justify-content:space-between;
                         border-bottom: 2px dashed #e7eaec;padding:0px 0px 20px 0px;"
        >
          <span style="position: relative;color: #3998F7;font-size: 22px;line-height: 32px;float: left"
            >周计划的完成情况
            <span
              style="line-height: 20px;font-size: 12px;padding: 0px 4px;
                                position: absolute;top: 12px;
                                background:#F5A623;
                                border-radius: 4px;margin-left: 10px;color: white;margin-top: -5px"
              >{{ completeDegree }}</span
            >
          </span>
          <span>
            <el-button type="danger" @click="dialogVisible = false" size="small" style="color: #FFF;background-color: #F56C6C;border-color: #F56C6C;">关闭</el-button>
          </span>
        </div>
        <el-row>
          <el-col>
            <span></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="text-align: center">
            <div>
              <el-button-group :class="$style.month" class="a_modal">
                <el-button size="small" icon="el-icon-arrow-left" @click.stop="lastNextMonthClick(-1)"></el-button>
                <el-button size="small" disabled>{{ dateWeekStr }}</el-button>
                <el-button size="small" icon="el-icon-arrow-right" @click.stop="lastNextMonthClick(1)"></el-button>
              </el-button-group>
            </div>
          </el-col>
        </el-row>
        <el-row style="padding: 0 100px">
          <el-col>
            <ul>
              <li
                v-for="(item, index) in modelWeekPlan"
                :key="index"
                style="height: auto;border: 1px solid #DCDFE6;margin:10px auto;
                                        border-radius:6px;overflow: hidden;padding: 5px 0px"
              >
                <div style="width: 20%;float: left;text-align: center">
                  <div style="height: 30px;text-align: center">
                    <img :src="item.icon" alt="" width="24" height="24" style="margin-top: 10px" />
                  </div>
                  <div style="height: 30px;text-align: center">
                    <span style="font-size: 12px;line-height: 30px">{{ item.text }}</span>
                  </div>
                </div>
                <div style="width: 68%;float: left">
                  <p style="margin: 10px 0 10px 0;font-size: 16px">{{ item.title }}</p>
                  <span v-if="item.status === '尚未完成'" style="font-size: 14px;color: #D0021B">{{ item.status }}</span>
                  <span v-else style="font-size: 14px;color: #6BC235">{{ item.status | changeFormat }}</span>
                </div>
                <div style="width: 10%;float: left;text-align: center;height: 60px">
                  <img :src="item.check" alt="" style="margin-top: 17px" width="24" height="24" />
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </el-dialog>
      <el-dialog title="" :visible.sync="dialogVisibleDay" :show-close="false" :before-close="handleClose">
        <div
          slot="title"
          class="dialog-footer"
          style="display: flex;justify-content:space-between;
                         border-bottom: 2px dashed #e7eaec;padding:0px 0px 20px 0px;"
        >
          <span style="color: #3998F7;font-size: 22px;line-height: 32px;float: left">日程 </span>
          <span>
            <el-button type="danger" @click="dialogVisibleDay = false" size="small" style="color: #FFF;background-color: #F56C6C;border-color: #F56C6C;">关闭</el-button>
          </span>
        </div>
        <el-row>
          <el-col style="text-align: center">
            <span v-if="MonthObj.date" style="font-size: 20px">
              {{ MonthObj.date }}
            </span>
            <span v-else style="font-size: 20px">
              <span>{{ MonthObj.str1 }}</span>
              <span
                style="display: inline-block;padding: 4px;
                               border-radius:50%;background: red;color:white"
              >
                {{ MonthObj.str2 }}</span
              ><span>日</span>
              <span>{{ MonthObj.str }}</span>
            </span>
          </el-col>
          <el-col style="margin-top: 20px">
            <el-row>
              <el-col v-for="(item, index) in MonthObj" :key="index" style="margin-top: 10px;margin-bottom: 10px">
                <div style="float: left;width: 30%;text-align: center;margin-top: 12px;">
                  <span style="display: inline-block;width: 70px;">{{ item.time }}</span>
                  <img :src="item.img" alt="" style="vertical-align: middle" />
                </div>
                <div style="float: left;font-size: 12px;width: 58%">
                  <p style="font-size: 16px">{{ item.institution_name }}</p>
                  <p style="color: #bbbbbb" v-html="item.address"></p>
                  <p style="color: #409EFF;" v-html="item.textValue1"></p>
                  <p style="color: #409EFF;">{{ item.text }}{{ item.num }}</p>
                  <p style="color: #409EFF;" v-html="item.textCreateBy"></p>
                  <p style="">
                    <span
                      v-for="(hcp_dept, j) in item.hcp_deptList"
                      style="margin-top: 5px;
                                            display: inline-block;padding: 6px;background: #FF9901;color: white;border-radius:3px;margin-right: 4px"
                    >
                      {{ hcp_dept.dept_name + "-" + hcp_dept.hcp_name }}</span
                    >
                  </p>
                  <p style="">
                    <span
                      v-for="(cust_list, j) in item.customer_List"
                      style="margin-top: 5px;
                                                        display: inline-block;padding: 6px;background: #FF9901;color: white;border-radius: 3px;margin-right: 4px"
                    >
                      {{ cust_list.name }}</span
                    >
                  </p>
                  <p v-for="(obj, j) in item.checkinArray" style="">
                    <span style="color: #F5A623;">{{ obj.str }}</span
                    ><span style="margin-left: 10px" :style="{ color: obj.str2 === '  尚未签出' ? 'red' : '#F5A623' }"> {{ obj.str2 }}</span>
                  </p>
                </div>
                <div style="float: left;width: 10%">
                  <i
                    class="el-icon-arrow-right"
                    style="line-height: 50px;
                                                            color: #bbbbbb"
                  ></i>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-dialog>
    </el-row>
  </el-row>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import "swiper/js/swiper.min.js";
import { AMapManager } from "vue-amap";
import http from "../../../APIService/http";
import activity from "../../../assets/images/activity.png";
import distributor from "../../../assets/images/distributor.png";
import greenCheck from "../../../assets/images/greenCheck.png";
import greenSuccess from "../../../assets/images/greenSuccess.png";
import left_png from "../../../assets/images/left.png";
import imgUrl from "../../../assets/images/mark_0.png";
import medicalvisit from "../../../assets/images/medicalvisit.png";
import oval from "../../../assets/images/Oval.png";
import redCheck from "../../../assets/images/redCheck.png";
import right_png from "../../../assets/images/right.png";
import store from "../../../assets/images/store.png";
import navBar from "../../../components/navBar";
import inputSelect from "./components/inputSelect";
let amapManager = new AMapManager();
export default {
  name: "calendar",
  data() {
    const self = this;
    return {
      tolls_distance: 0,
      mySwiper: {},
      amapManager,
      zoom: 10,
      mapArray: [],
      centers: [],
      center: [121.59996, 31.197646],
      lng: 0,
      lat: 0,
      loaded: false,
      plugin: [
        {
          pName: "ToolBar",
          position: "RT",
          locate: false,
          events: {
            init(instance) {},
          },
        },
      ],
      btnOff: false,
      mapOff: true,
      role: "",
      tags: ["日程安排"],
      titleName: this.$store.getters.getUser.role === "staff" ? this.$store.getters.getUser.alias : this.GLOBAL.peopleName_global,
      title: this.$store.getters.getUser.role === "staff" ? this.$store.getters.getUser.alias : "管理员",
      subTitle: "日程表",
      activeName: "日",
      value: new Date(),
      array: [1, 2],
      dateStr: "2019年9月15日-9月21日",
      people: "",
      arrayMonth: [],
      dateArr: [
        [
          {
            date: "2019-12-01",
            month: "cur",
            scheduleArray: [
              {
                absence_hours: "",
                arrive_late_minutes: "",
                clerk_id: "",
                end_time: "",
                end_time_tolerance: 0,
                first_check_in: "",
                icon_color: "155,155,155",
                icon_text: "未排班",
                key_id: "",
                last_check_out: "",
                last_name: "wk",
                leave_early_minutes: "",
                leave_hours: "",
                off_hours: "",
                original_shift: "",
                ot_hours: "",
                schedule_date: "2019-12-01",
                schedule_shift: "",
                shift_name: "",
                start_time: "",
                start_time_tolerance: 0,
                tenant_id: "8169254764",
                user_id: "3513788528",
              },
              {
                absence_hours: "",
                arrive_late_minutes: "",
                clerk_id: "",
                end_time: "",
                end_time_tolerance: 0,
                first_check_in: "",
                icon_color: "155,155,155",
                icon_text: "未排班",
                key_id: "",
                last_check_out: "",
                last_name: "哇啊",
                leave_early_minutes: "",
                leave_hours: "",
                off_hours: "",
                original_shift: "",
                ot_hours: "",
                schedule_date: "2019-12-01",
                schedule_shift: "",
                shift_name: "",
                start_time: "",
                start_time_tolerance: 0,
                tenant_id: "8169254764",
                user_id: "6125425262",
              },
            ],
          },
        ],
        [
          {
            date: "2019-12-03",
            month: "cur",
          },
        ],
      ],
      dateArrConst: [],
      dialogVisible: false,
      dialogVisibleDay: false,
      calendarDate: moment().format("YYYY-MM-DD"),
      thisMonth: moment().format("YYYY年M月"),
      thisDay: moment().format("M 月"),
      thisDayStr: moment().format("D"),
      thisDayWeek: moment().format("d"),
      thisDate: moment().format("YYYY-MM-DD"),
      dateWeekStr: "",
      numdateWeekStr: "",
      dateConst: "",
      dateConstSunday: "",
      dateMonthStr: "",
      dataMonthConst: "",
      dayArray: [],
      greenSuccess: greenSuccess,
      oval: oval,
      selectPeople: this.$store.getters.getUser.role === "staff" ? this.$store.getters.getUser.user_id : "",
      selectPeopleManager: "",
      selectPeopleMonth: this.$store.getters.getUser.user_id,
      options: [],
      weekArray: [],
      tableTrArray: [],
      year: "",
      month: "",
      today: new Date(),
      MonthObj: [],
      monthArr: [],
      dateOne: "",
      dateStrMonth: "",
      modelWeekPlan: [],
      store: store,
      activity: activity,
      completeDegree: "",
      thisWeek: moment().format("YYYY年M月"),
      marginValue: "",
      onoff: false,
      onoffTow: false,
      onoffLi: false,
      onoffSelect: true,
      timer: "",
      weekLiMargin_Left: false,
      weekLiMargin_text_left: "查看周日",
      weekLiMargin_Right: false,
      weekLiMargin_text_right: "查看周六",
      left_png: left_png,
      right_png: right_png,
      copycalendarDate: moment().format("YYYY-MM-DD"),
    };
  },
  components: {
    navBar,
    inputSelect,
  },
  filters: {
    getCD(val) {
      return parseInt(val.split("-")[2]);
    },
    changeFormat(val) {
      let time = val.split(":")[1];
      return moment(time).format("YYYY年M月D日");
    },
  },
  created() {
    localStorage.setItem("active", 1);
    if (this.dateOne) {
      this.dateOne = obj.dateOne;
    } else {
      this.dateOne = moment();
    }
    this.dateStrMonth = this.getCurrentDate();
    this.year = this.today.getFullYear();
    this.month = this.today.getMonth() + 1;
    this.day = this.today.getDay();
    this.date = this.today.getDate();
    this.getCalendar();
    this.init();
    this.getManager();
    this.role = this.$store.getters.getUser.role;
    // this.getPlanCompleteByWeek()
  },
  mounted() {
    if (this.$store.getters.getUser.role === "staff") {
      this.btnOff = true;
    }

    if (!this.isManager) {
      this.getVisitCoverStaffTerritory();
      // this.getData()
    }
    this.planWeekFun();
    let prevBtn = document.querySelector(".el-calendar__button-group .el-button-group>button:nth-child(1)");
    prevBtn.addEventListener("click", (e) => {
      this.calendarDate = this.copycalendarDate;
      this.calendarDate = moment(this.calendarDate)
        .subtract(1, "months")
        .format("YYYY-MM-DD HH:mm:ss");
    });

    //点击下一个月
    let nextBtn = document.querySelector(".el-calendar__button-group .el-button-group>button:nth-child(3)");
    nextBtn.addEventListener("click", () => {
      this.calendarDate = this.copycalendarDate;
      this.calendarDate = moment(this.calendarDate)
        .add(1, "months")
        .format("YYYY-MM-DD HH:mm:ss");
    });
  },
  watch: {
    calendarDate: function(newValue, oldValue) {
      this.copycalendarDate = newValue;
      this.thisMonth = moment(newValue).format("YYYY年M月");
      this.thisDay = moment(newValue).format("M 月");
      this.thisDayStr = moment(newValue).format("D");
      this.thisDate = moment(newValue).format("YYYY-MM-DD");
      this.thisDayWeek = moment(newValue).format("E");
      // this.getPlanCompleteByWeek('Date')
      this.init();
      this.planWeekFun();
      this.getRouteMapData();
    },
    dateArr: {
      deep: true,
      handler: function(val, oldVal) {
        this.startTime = val[0][0].date;
        this.endTime = val[5][6].date;
        this.setMonth(this.year + "-" + this.month, [this.startTime, this.endTime]);
      },
    },
  },
  methods: {
    switchMap() {
      this.mapOff = !this.mapOff;

      this.getRouteMapData();
    },
    mapArrayClick(item) {
      this.mapArray.forEach((item) => {
        item.selected = false;
      });

      item.selected = true;
      this.center = [item.lng, item.lat];
      this.zoom = 15;
    },
    async getVisitCoverStaffTerritory() {
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          month: this.GLOBAL.date,
        };
        http.post("/wapi/v1/getVisitCoverStaffTerritory", data).then((res) => {
          if (res.success) {
            this.GLOBAL.territory_id = res.data;
          }
        });
      } catch (e) {}
    },
    getRouteMapData() {
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {};
        data.tenant_id = this.$store.getters.getUser.tenant_id;
        data.user_id = this.$store.getters.getUser.user_id;
        data.role = this.$store.getters.getUser.role;
        data.date = moment(this.calendarDate).format("YYYY-MM-DD");
        if (this.$store.getters.getUser.role == "staff") {
          data.owner_id = this.selectPeople;
        } else {
          data.owner_id = this.GLOBAL.selectPeople_global;
          if (this.GLOBAL.selectOu_global != "") {
            data.owner_id = "";
            data.ou_id = this.GLOBAL.selectOu_global;
          }
        }
        http.post("/wapi/Calendar/getRouteMapData", data).then((res) => {
          let that = this;
          if (res.success) {
            that.mapArray = res.data;
            that.centers = [];
            this.$nextTick(() => {
              this.mySwiper = new Swiper(".swiper-container", {
                slidesPerView: "auto",
                freeMode: true,
                grabCursor: true,
              });
            });
            if (that.mapArray.length > 0) {
              that.mapArray[0].selected = true;
              that.center = [that.mapArray[0].lng, that.mapArray[0].lat];

              that.mapArray.forEach((item, index) => {
                that.centers.push({
                  position: [item.lng, item.lat],
                  template: `<div style="width: 22px;color:#fff;height: 30px;text-align: center; font-size: 12px; line-height: 20px; background:url(${imgUrl})">${index + 1}</div>`,
                  events: {
                    click: () => {
                      this.mySwiper.slideTo(index, 1000, false);
                      that.mapArray.forEach((item1, index1) => {
                        item1.selected = false;
                      });
                      item.selected = true;
                    },
                  },
                  visible: true,
                });
              });

              if (that.mapArray.length > 1) {
                //基本地图加载
                var map = amapManager.getMap();
                //构造路线导航类

                var driving = new AMap.Driving({
                  map: map,
                  policy: AMap.DrivingPolicy.LEAST_TIME,
                });

                var Arr = that.mapArray.concat();
                var waypointsArr = [];

                Arr.pop();
                Arr.shift();
                Arr.forEach((item) => {
                  waypointsArr.push(new AMap.LngLat(item.lng, item.lat));
                });
                console.log(that.mapArray, 4);

                // 根据起终点经纬度规划驾车导航路线
                driving.search(
                  new AMap.LngLat(that.mapArray[0].lng, that.mapArray[0].lat),
                  new AMap.LngLat(that.mapArray[that.mapArray.length - 1].lng, that.mapArray[that.mapArray.length - 1].lat),
                  { waypoints: waypointsArr },
                  function(status, result) {
                    // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/wapi/javascript-api/reference/route-search#m_DrivingResult
                    if (status === "complete") {
                      that.tolls_distance = (result.routes[0].distance / 1000).toFixed(1);
                      // log.success('绘制驾车路线完成')
                    } else {
                      // log.error('获取驾车数据失败：' + result)
                    }
                  }
                );
              }
            } else {
              that.center = [116.46, 39.92];
              that.centers.length = 0;
            }
            this.judeg(that.mapArray);

            loading.close();
          }
        });
      } catch (e) {
        loading.close();
      }
    },

    setMonth(date) {
      // this.$emit('setMonth', date, [this.startTime, this.endTime])
    },
    async init() {
      try {
        let loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let data = {};
        data.tenant_id = this.$store.getters.getUser.tenant_id;
        data.user_id = this.$store.getters.getUser.user_id;
        data.role = this.$store.getters.getUser.role;
        // data.clientObj = this.$store.getters.getClient
        data.date = moment(this.calendarDate).format("YYYY-MM-DD");

        if (this.$store.getters.getUser.role == "staff") {
          data.owner_id = this.selectPeople;
        } else {
          data.owner_id = this.GLOBAL.selectPeople_global;
          if (this.GLOBAL.selectOu_global != "") {
            data.owner_id = "";
            data.ou_id = this.GLOBAL.selectOu_global;
          }
        }
        if (this.activeName == "日") {
          data.week = "F";
        } else if (this.activeName == "周") {
          data.week = "T";
          data.date = this.dateConst;
        } else if (this.activeName == "月") {
          data.week = "M";
          data.date = this.dataMonthConst;
          data.dateArr = this.dateArrConst;
          if (this.$store.getters.getUser.role === "staff") {
            data.owner_id = this.selectPeople;
          } else {
            data.owner_id = this.GLOBAL.selectPeople_global;
            if (this.GLOBAL.selectOu_global != "") {
              data.owner_id = "";
              data.ou_id = this.GLOBAL.selectOu_global;
            }
          }
        }
        await http
          .post("/wapi/Calendar/getScheduleListByDay", data)
          .then((res) => {
            loading.close();
            if (res.success === true) {
              if (this.activeName === "日") {
                this.dayArray = res.data;
                this.judeg(this.dayArray);
              } else if (this.activeName === "周") {
                // console.log(res.data,111)
                this.dayArray = res.data;
                this.judeg(this.dayArray);
                let tomorrow1 = moment(this.dateConst).format("YYYY-MM-DD");
                let tomorrow2 = moment(tomorrow1)
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                let tomorrow3 = moment(tomorrow2)
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                let tomorrow4 = moment(tomorrow3)
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                let tomorrow5 = moment(tomorrow4)
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                let tomorrow6 = moment(tomorrow5)
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                let tomorrow7 = moment(tomorrow6)
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                let array = [[], [], [], [], [], [], []];
                let weekArray = [[], []];
                for (let i = 0; i < this.dayArray.length; i++) {
                  let activity_date = this.dayArray[i].dateStr;
                  if (activity_date === tomorrow1) {
                    let obj = this.dayArray[i];
                    array[1].push(obj);
                  } else if (activity_date === tomorrow2) {
                    let obj = this.dayArray[i];
                    array[2].push(obj);
                  } else if (activity_date === tomorrow3) {
                    let obj = this.dayArray[i];
                    array[3].push(obj);
                  } else if (activity_date === tomorrow4) {
                    let obj = this.dayArray[i];
                    array[4].push(obj);
                  } else if (activity_date === tomorrow5) {
                    let obj = this.dayArray[i];
                    array[5].push(obj);
                  } else if (activity_date === tomorrow6) {
                    let obj = this.dayArray[i];
                    array[6].push(obj);
                    weekArray[0].push(obj);
                  } else if (activity_date === tomorrow7) {
                    let obj = this.dayArray[i];
                    array[0].push(obj);
                    weekArray[1].push(obj);
                  }
                }
                this.arrayMonth = array;
              } else if (this.activeName === "月") {
                let objDateArr = JSON.parse(JSON.stringify(res.data));
                this.judegLength(objDateArr);

                // this.weekArray= res.data
                // this.judeg(this.weekArray)
                // let arr = this.copyFn(this.tableTrArray)
                // if (this.weekArray.length>0){
                //     for (let i=0;i<arr.length;i++){
                //         for (let j=0;j<arr[i].length;j++){
                //             this.weekArray.filter((item,k)=>{
                //                 if (item.activity_date == arr[i][j].date){
                //                     arr[i][j].scheduleArray.push(item)
                //                 }
                //             })
                //         }
                //     }
                // }
                // console.log(arr)
              }
            }
          })
          .catch((err) => {
            loading.close();
          });
      } catch (e) {}
    },
    judegLength(arr) {
      let array = JSON.parse(JSON.stringify(arr));
      let institutionNum = 0;
      let institutionText = 0;
      let eventText = [];
      let Leave = [];
      let travel = [];
      let internal = [];
      let coaching = [];
      let disList = [];
      let disListNum = 0;
      let disListText = 0;
      for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < array[i].length; j++) {
          let item = array[i][j];
          item.arr.filter((obj, k) => {
            if (obj.category === "COACHING") {
              let str;
              if (obj.value1) {
                str = "协访/辅导：" + obj.value1 + "(" + obj.coach_name + ")";
              } else {
                str = "协访/辅导：" + "(" + obj.coach_name + ")";
              }

              coaching.push(str);
            }
            if (obj.category === "DISTRIBUTOR") {
              if (obj.actual_num) {
                disListNum++;
                disListText += parseInt(obj.actual_num);
              }
            }

            if (obj.category === "HCP_CALL") {
              if (obj.actual_num) {
                institutionNum++;
                institutionText += parseInt(obj.actual_num);
              }
            }
            if (obj.category === "MEETING") {
              let str = "";
              str = "会议/ 活动：" + obj.value1 + "（" + "计划参会：" + obj.plan_visit_num + "人）";
              eventText.push(str);
            }
            if (obj.category === "TRAVEL") {
              let str = "";
              str = "差旅/计划：" + obj.value1;
              travel.push(str);
            }
            if (obj.category === "INTERNAL") {
              if (obj.type == "TRAINING") {
                let str = "";
                let strday = "";
                if (obj.activity_duration === "FORENOON") {
                  strday = "上午";
                } else if (obj.activity_duration === "FULLDAY") {
                  strday = "全天";
                } else if (obj.activity_duration === "AFTERNOON") {
                  strday = "下午";
                }
                str = "公司会议/培训：" + obj.value1 + "(" + strday + ")";
                internal.push(str);
              }
              if (obj.type == "LEAVE_TYPE") {
                let str = "";
                let strday = "";
                if (obj.activity_duration === "FORENOON") {
                  strday = "上午";
                } else if (obj.activity_duration === "FULLDAY") {
                  strday = "全天";
                } else if (obj.activity_duration === "AFTERNOON") {
                  strday = "下午";
                }
                str = "请假/休假：" + obj.value1 + "(" + strday + ")";
                internal.push(str);
              }
              if (obj.type == "PAPERWORK") {
                let str = "";
                let strday = "";
                if (obj.activity_duration === "FORENOON") {
                  strday = "上午";
                } else if (obj.activity_duration === "FULLDAY") {
                  strday = "全天";
                } else if (obj.activity_duration === "AFTERNOON") {
                  strday = "下午";
                }
                str = "内部工作：" + obj.value1 + "(" + strday + ")";
                internal.push(str);
              }
            }
          });
          if (institutionNum || institutionText) {
            item.institutionNum = "医务拜访：" + institutionNum + "家机构，" + institutionText + "名医务人员";
          } else {
            delete item.institutionNum;
          }
          if (disListNum || disListText) {
            item.disListNum = "商务拜访：" + disListNum + "家经销商，" + disListText + "名联系人";
          } else {
            delete item.disListNum;
          }

          if (eventText.length > 0) {
            item.eventText = eventText;
          } else {
            delete item.eventText;
          }
          if (travel.length > 0) {
            item.travel = travel;
          } else {
            delete item.travel;
          }
          if (internal.length > 0) {
            item.internal = internal;
          } else {
            delete item.internal;
          }
          if (coaching.length > 0) {
            item.coaching = coaching;
          } else {
            delete item.coaching;
          }

          institutionNum = 0;
          institutionText = 0;
          disListNum = 0;
          disListText = 0;
          eventText = [];
          Leave = [];
          travel = [];
          internal = [];
          coaching = [];
          disList = [];
        }
      }
      this.dateArr = array;
      this.$forceUpdate();
    },
    async getManager() {
      try {
        let data = {
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
        };
        await http.post("/wapi/Calendar/getManger", data).then((res) => {
          this.options = res.data;
          let obj = {
            user_id: "",
            user_name: "所有下属",
          };
          this.options.unshift(obj);
        });
      } catch (e) {}
    },
    // 修改班次的背景色
    getBackground(color) {
      return "rgb(" + color + ")";
    },
    vshow(schedule_shift) {
      if (schedule_shift) {
        return true;
      }
      return false;
    },
    monthClass(type) {
      if (type !== "cur") {
        return true;
      } else {
        return false;
      }
    },
    monthColor(type) {
      let nowDate = moment().format("YYYY-MM-DD");
      if (type === nowDate) {
        return true;
      }
    },
    contains(arr) {
      if (arr[0] == "" && arr[1] == "" && arr[2] == "" && arr[3] == "" && arr[4] == "" && arr[5] == "" && arr[6] == "") {
        return false;
      } else {
        return true;
      }
    },
    // 修改班表状态颜色
    getStatusBackground(str) {
      switch (str) {
        case "SUBMITTED": //已提交
          // tv_status.setText("班表已提交待审");
          // tv_status.setTextColor(Color.parseColor("#4A90E2"));

          // submit.setText("审批班表");
          // submit.setTextColor(Color.parseColor("#7ED321"));
          return "#4A90E2";
        case "APPROVED": //已批准
          // tv_status.setText("班表已审核生效");
          // tv_status.setTextColor(Color.parseColor("#7ED321"));

          // submit.setText("撤回班表");
          // submit.setTextColor(Color.parseColor("#D0021B"));
          return "#7ED321";

        case "REJECTED": //已拒绝或已撤回
          // tv_status.setText("班表已撤回");
          // tv_status.setTextColor(Color.parseColor("#D0021B"));

          // submit.setText("提交班表");
          // submit.setTextColor(Color.parseColor("#4A90E2"));
          return "#D0021B";
        default:
          //未提交
          // tv_status.setText("班表尚未提交");
          // tv_status.setTextColor(Color.parseColor("#D0021B"));

          // submit.setText("提交班表");
          // submit.setTextColor(Color.parseColor("#4A90E2"));
          return "#D0021B";
      }
    },
    //新增按钮
    handleAdd() {},
    //返回按钮
    handleBackClick() {},
    planWeekFun() {
      // let days = moment(this.thisDate).format('E')
      // let nextMonday = moment(this.thisDate).subtract(days-1, 'days').format('YYYY-MM-DD')//周一
      // let nextSunday = moment(this.thisDate).subtract(days-7, 'days').format('YYYY-MM-DD');//周日日期
      //
      let now = this.thisDate;
      let weekOfday = moment(now).format("E"); //获取在一周的第几天
      this.dateConst = moment(now)
        .subtract(weekOfday - 1, "days")
        .format("YYYY-MM-DD"); //周一日期
      this.dateConstSunday = moment(now)
        .subtract(weekOfday - 7, "days")
        .format("YYYY-MM-DD"); //周日日期
      let date = moment(this.thisDate).format("E");
      let Monday = moment(this.thisDate)
        .subtract(date - 1, "days")
        .format("M月D日");
      let Monday_a = moment(this.thisDate)
        .subtract(date - 1, "days")
        .format("YYYY-MM-DD");
      let Sunday = moment(this.thisDate)
        .add(7 - date, "days")
        .format("M月D日");
      this.dateWeekStr = Monday + " - " + Sunday;
      this.numdateWeekStr = Monday_a;
      this.Monday = Monday_a;
      this.getPlanCompleteByWeek();
    },
    handleClickTabs() {
      if (this.activeName == "周") {
        this.planWeekFun();
      } else if (this.activeName == "月") {
        this.dateMonthStr = moment(new Date()).format("YYYY年M月");
        this.dataMonthConst = moment(new Date()).format("YYYY-MM-DD");
        // let nowDate = moment(this.dataMonthConst).startOf('month').format('YYYY-MM-DD')
        // let end = parseInt(moment().endOf('month').format('DD'))
        // console.log(end)
        // let array= [[],[],[],[],[]]
        // for (let i=0;i<end;i++){
        //
        //     var dateStr = moment(nowDate).add(i, "days").format("YYYY-MM-DD");
        //     if (i < 7){
        //         let obj = {
        //             date : dateStr,
        //             month:'cur',
        //             scheduleArray :[]
        //         }
        //         array[0].push(obj)
        //     } else if (i<14){
        //         let obj = {
        //             date : dateStr,
        //             month:'cur',
        //             scheduleArray :[]
        //         }
        //         array[1].push(obj)
        //     } else if (i<21){
        //         let obj = {
        //             date : dateStr,
        //             month:'cur',
        //             scheduleArray :[]
        //         }
        //         array[2].push(obj)
        //     } else if (i<28){
        //         let obj = {
        //             date : dateStr,
        //             month:'cur',
        //             scheduleArray :[]
        //         }
        //         array[3].push(obj)
        //     } else if (i<35){
        //         let obj = {
        //             date : dateStr,
        //             month:'cur',
        //             scheduleArray :[]
        //         }
        //         array[4].push(obj)
        //     }
        // }
        //  this.dateArr = array
        //  this.tableTrArray = this.copyFn(array)
      }

      this.init();
      this.getManager();
    },
    handleSelectInputClick(j) {
      if (j.length == 10) {
        this.btnOff = true;
      } else {
        this.btnOff = false;
      }

      this.getPlanCompleteByWeek();
      for (let i = 0; i < this.options.length; i++) {
        if (j === this.options[i].user_id) {
          this.titleName = this.options[i].user_name;
        }
      }
      this.onoffSelect = false;
      this.GLOBAL.selectPeople_global = j;
      this.titleName = this.GLOBAL.peopleName_global;
      this.onoffSelect = true;
      this.timer = new Date().getTime();
      this.init();
    },
    // copyFn(obj) {
    //
    //     if (obj == null) {
    //         return null
    //     }
    //     var result = Array.isArray(obj) ? [] : {};
    //     for (let key in obj) {
    //         if (obj.hasOwnProperty(key)) {
    //             if (typeof obj[key] === 'object') {
    //                 result[key] = this.copyFn(obj[key]);  // 如果是对象，再次调用该方法自身
    //             } else {
    //                 result[key] = obj[key];
    //             }
    //         }
    //     }
    //     return result;
    //
    // },
    judeg(array) {
      let dataArray = [];
      for (let i = 0; i < array.length; i++) {
        let obj = array[i];
        if (obj.completed === "T") {
          obj.img = greenSuccess;
        } else {
          obj.img = oval;
        }

        if (obj.category === "COACHING") {
          if (obj.submitted_date === "") {
            obj.confirmed_resultText = "计划未提交";
          }

          if (!(obj.submitted_date === "") && obj.confirmed_date === "") {
            obj.confirmed_resultText = "计划待确认";
          }

          if (!(obj.confirmed_date === "") && obj.confirmed_result === "APPROVED") {
            obj.confirmed_resultText = "计划已确认";
          }

          if (!(obj.confirmed_date === "") && obj.confirmed_result === "DENIED") {
            obj.confirmed_resultText = "计划被拒绝";
          }
          if (obj.completed === "T") {
            obj.confirmed_resultText = "协访已完成";
          }
          if (obj.confirmed_resultText === "") {
            obj.confirmed_resultText = "计划进行中";
          }
        } else {
          if (obj.status === "SUBMITTED") {
            obj.confirmed_resultText = "待审核";
          }
          if (obj.status === "APPROVED") {
            obj.confirmed_resultText = "已批准";
          }
          if (obj.status === "DENIED") {
            obj.confirmed_resultText = "已拒绝";
          }
          if (obj.status === "ACTIVE" || obj.status === "DRAFT") {
            obj.confirmed_resultText = "未提交";
          }
          if (obj.completed === "T") {
            obj.confirmed_resultText = "已完成";
          }
        }

        switch (obj.category) {
          case "HCP_CALL":
            obj.institution_name = obj.institution_name;
            obj.address = obj.address;
            // obj.text = "计划拜访客户："+obj.plan_visit_num+"人 | " + "实际拜访："+obj.actual_num+"人";
            obj.text = "拜访医务人员：" + obj.actual_num + "人";
            obj.textValue1 = "拜访目的：" + obj.value1;
            break;
          case "MEETING":
            obj.institution_name = obj.title;
            obj.address = obj.address;
            obj.num = obj.value1 + "（" + "计划参会：" + obj.plan_visit_num + "人）";
            obj.textCreateBy = "发起人：" + obj.alias + " [" + obj.confirmed_resultText + "]";
            break;
          case "TRAVEL": //差旅计划
            // if (obj.start_time == obj.end_time) {
            //    obj.institution_name = moment(obj.start_time).format('MM月DD日')+"("
            //        +this.weekText(obj.start_time,1)+ ")"
            // }else {
            //     obj.institution_name = moment(obj.start_time).format('MM月DD日')+"("
            //         +this.weekText(obj.start_time,1)+ ")"+ "-"+moment(obj.end_time).format('MM月DD日')+"("
            //         +this.weekText(obj.end_time,1)+ ")"
            // }
            if (obj.value1 === obj.value2) {
              obj.institution_name = "出差：" + obj.value1;
            } else {
              obj.institution_name = "出差：" + obj.value2 + "—" + obj.value1;
            }

            // if (obj.address === ''){
            //     obj.address = ''
            // } else {
            //     obj.address = obj.address
            // }
            obj.num = "审批状态：" + "[" + obj.confirmed_resultText + "]";

            break;
          case "INTERNAL":
            // obj.institution_name=moment(obj.activity_date).format('MM月DD日')+"("
            //     +this.weekText(obj.activity_date,1)+ ")"
            // if (obj.address === ''){
            //     obj.address = ''
            // } else {
            //     obj.address = obj.address
            // }
            obj.institution_name = obj.value1;
            obj.num = "审批状态：" + "[" + obj.confirmed_resultText + "]";
            break;
          case "LEAVE_TYPE":
            obj.institution_name = obj.value1;
            obj.num = "审批状态：" + "[" + obj.confirmed_resultText + "]";
            break;
          case "DISTRIBUTOR":
            obj.institution_name = obj.title;
            obj.text = "拜访联系人：" + obj.actual_num + "人";
            obj.textValue1 = "拜访目的：" + obj.value1;
            break;
          case "COACHING":
            obj.institution_name = obj.value1;
            obj.address = "协访人：" + obj.coach_name + "&nbsp;&nbsp;&nbsp;&nbsp;" + "被协访人：" + obj.coachee_name;
            obj.textCreateBy = "创建人：" + obj.alias + "&nbsp;&nbsp;&nbsp;" + "[" + obj.confirmed_resultText + "]";
            break;
        }
        if (obj.checkinArray.length > 0) {
          for (let i = 0; i < obj.checkinArray.length; i++) {
            let onoff = false;
            let str = "";
            let str2 = "";
            if (obj.checkinArray[i].checkin_time != "") {
              let checkin_time = obj.checkinArray[i].checkin_time.substring(11, 16);
              str = "签入 " + checkin_time;
            }
            if (obj.checkinArray[i].checkout_time != "") {
              let checkout_time = obj.checkinArray[i].checkout_time.substring(11, 16);
              str2 += "  签出 " + checkout_time;
              onoff = true;
            } else {
              str2 += "  尚未签出";
            }
            obj.checkinArray[i].str = str;
            obj.checkinArray[i].str2 = str2;
          }
        }
      }
    },
    getCalendar() {
      var len = this.getLen();
      var d = new Date(this.year, this.month - 1, 1);
      var dfw = d.getDay();
      var arr = new Array();
      var tem = 0;
      var nextTem = 1;
      var pre = dfw - 1;

      let date = moment(this.dateOne);

      var _lastLen = this.getLen(this.month - 1);

      for (var i = 0; i < 6; i++) {
        arr[i] = new Array();
        for (var j = 0; j < 7; j++) {
          tem++;
          if (tem - dfw > 0 && tem - dfw <= len) {
            arr[i][j] = {
              date: this.year + "-" + this.getFormatDate(date.month() + 1) + "-" + this.getFormatDate(tem - dfw),
              month: "cur",
              scheduleArray: [],
            };
          } else {
            if (tem <= dfw) {
              if (date.month() === 0) {
                let dateC = moment(this.dateOne);
                let dateNew = dateC.add(-1, "months");

                arr[i][j] = {
                  date: dateNew.year() + "-" + this.getFormatDate(dateNew.month() + 1) + "-" + (_lastLen - pre),
                  month: "pre",
                  scheduleArray: [],
                };
              } else {
                arr[i][j] = {
                  date: this.year + "-" + this.getFormatDate(date.month()) + "-" + (_lastLen - pre),
                  month: "pre",
                  scheduleArray: [],
                };
              }

              pre--;
            } else {
              if (date.month() === 11) {
                let dateC = moment(this.dateOne);
                let dateNew = dateC.add(1, "months");

                arr[i][j] = {
                  date: dateNew.year() + "-" + this.getFormatDate(dateNew.month() + 1) + "-" + this.getFormatDate(nextTem),
                  month: "next",
                  scheduleArray: [],
                };
              } else {
                arr[i][j] = {
                  date: this.year + "-" + this.getFormatDate(date.month() + 2) + "-" + this.getFormatDate(nextTem),
                  month: "next",
                  scheduleArray: [],
                };
              }

              nextTem++;
            }
          }
        }
      }

      //判断是否有第6行

      let dayObj = arr[5];
      let monthStr = dayObj[0].date.substring(0, 7);
      let mStr = moment(this.dateOne).format("YYYY-MM");
      if (monthStr !== mStr) {
        arr.splice(5);
      }

      this.dateArr = JSON.parse(JSON.stringify(arr));
      this.monthArr = JSON.parse(JSON.stringify(arr));
      this.dateArrConst = JSON.parse(JSON.stringify(arr));
      // console.log(this.dateArr);
    },
    getLen(m) {
      const month = m || this.month;
      if (month == 2) {
        if (this.isLeap()) {
          return 29;
        } else {
          return 28;
        }
      } else {
        if (month < 8) {
          if (month % 2 > 0) {
            return 31;
          } else {
            return 30;
          }
        } else {
          if (month % 2 > 0) {
            return 30;
          } else {
            return 31;
          }
        }
      }
    },
    isLeap() {
      const year = this.year;
      if (year % 4 > 0) {
        return false;
      } else if (year % 100 == 0 && year % 400 > 0) {
        return false;
      } else {
        return true;
      }
    },
    getFormatDate(arg) {
      if (!arg) {
        return "";
      }
      var re = arg + "";
      if (re.length < 2) {
        re = "0" + re;
      }
      return re;
    },
    weekText(j, i) {
      if (i == 1) {
        j = moment(j).day();
      } else if (i == 0) {
        j = j + 1;
      }
      j = parseInt(j);
      switch (j) {
        case 1:
          return "周一";
        case 2:
          return "周二";
        case 3:
          return "周三";
        case 4:
          return "周四";
        case 5:
          return "周五";
        case 6:
          return "周六";
        case 0:
          return "周日";
      }
    },
    weekTextWeek(j) {
      j = parseInt(j);
      switch (j) {
        case 1:
          return "周一";
        case 2:
          return "周二";
        case 3:
          return "周三";
        case 4:
          return "周四";
        case 5:
          return "周五";
        case 6:
          return "周六";
        case 7:
          return "周日";
      }
    },
    lastNextMonthClick(i) {
      // let lastMonday = moment(date).subtract(weekOfDay-1, 'days').format('YYYY-MM-DD');//周一日期
      // let lastTuesday = moment(date).subtract(weekOfDay-2, 'days').format('YYYY-MM-DD');//周二日期
      // let lastWednesday = moment(date).subtract(weekOfDay-3, 'days').format('YYYY-MM-DD');//周三日期
      // let lastThursday = moment(date).subtract(weekOfDay-4, 'days').format('YYYY-MM-DD');//周四日期
      // let lastFriday = moment(date).subtract(weekOfDay-5, 'days').format('YYYY-MM-DD');//周五日期
      // let lastSaturday = moment(date).subtract(weekOfDay-6, 'days').format('YYYY-MM-DD');//周六日期
      // let lastSunday = moment(date).add(weekOfDay-7, 'days').format('YYYY-MM-DD');//周日日期
      if (i == -1) {
        let day = moment(this.dateConst).format("E");
        let M = moment(this.dateConst)
          .subtract(day - 1, "days")
          .format("YYYY-MM-DD"); //周一日期
        let Monday = moment(M)
          .subtract(1, "days")
          .format("YYYY-MM-DD"); //获取上一个星期的最后一天
        let weekOfday = moment(Monday).format("E"); //获取在一周的第几天
        let lastSunday = moment(Monday)
          .add(weekOfday - 7, "days")
          .format("M月D日"); //周日日期
        let dateConstSunday = moment(Monday)
          .add(weekOfday - 7, "days")
          .format("YYYY-MM-DD"); //周日日期
        let lastMonday = moment(Monday)
          .subtract(weekOfday - 1, "days")
          .format("M月D日"); //周一日期
        this.thisWeek = moment(Monday)
          .subtract(weekOfday - 1, "days")
          .format("YYYY年M月"); //周一日期
        let lastMonday_a = moment(Monday)
          .subtract(weekOfday - 1, "days")
          .format("YYYY-MM-DD"); //周一日期
        this.dateConst = lastMonday_a;
        this.dateConstSunday = dateConstSunday;
        this.dateWeekStr = lastMonday + " - " + lastSunday;
        this.numdateWeekStr = lastMonday_a;
        this.init();
        this.getPlanCompleteByWeek();
      } else {
        let day = moment(this.dateConst).format("E");
        let M = moment(this.dateConst)
          .subtract(day - 7, "days")
          .format("YYYY-MM-DD"); //周日日期
        // let Monday = moment(M).subtract(1, 'days').format('YYYY-MM-DD')//下个星期第一天
        let Monday = moment(M)
          .add(1, "days")
          .format("YYYY-MM-DD");
        let days = moment(Monday).format("E");
        let nextSunday = moment(Monday)
          .subtract(days - 7, "days")
          .format("M月D日"); //周日日期
        let dateConstSunday = moment(Monday)
          .subtract(days - 7, "days")
          .format("YYYY-MM-DD"); //周日日期
        let nextMonday = moment(Monday)
          .subtract(days - 1, "days")
          .format("M月D日"); //周一
        this.thisWeek = moment(Monday)
          .subtract(days - 1, "days")
          .format("YYYY年M月"); //周一
        let nextMonday_a = moment(Monday)
          .subtract(days - 1, "days")
          .format("YYYY-MM-DD"); //周一
        this.dateConst = nextMonday_a;
        this.dateConstSunday = dateConstSunday;
        this.dateWeekStr = nextMonday + " - " + nextSunday;
        this.numdateWeekStr = nextMonday_a;
        this.init();
        this.getPlanCompleteByWeek();
      }
    },
    getCurrentDate() {
      let date = moment(this.dateOne);
      return date.year() + "年" + this.getFormatDate(date.month() + 1) + "月";
    },
    lastNextMonthClickMonth(num) {
      if (num == -1) {
        this.dateMonthStr = moment(this.dataMonthConst)
          .subtract(1, "months")
          .format("YYYY年M月");
        this.dataMonthConst = moment(this.dataMonthConst)
          .subtract(1, "months")
          .format("YYYY-MM-DD");
      } else if (num == 1) {
        this.dateMonthStr = moment(this.dataMonthConst)
          .add(1, "months")
          .format("YYYY年M月");
        this.dataMonthConst = moment(this.dataMonthConst)
          .add(1, "months")
          .format("YYYY-MM-DD");
      }

      let currentDate = moment(this.dateOne);
      let date = currentDate.add(num, "months");
      this.dateOne = date;
      this.dateStrMonth = date.year() + "年" + this.getFormatDate(date.month() + 1) + "月";
      this.year = date.year();
      this.month = this.getFormatDate(date.month() + 1);
      this.getCalendar();
      this.init();
    },
    getdblclickInfo(obj, date, type) {
      if (type !== undefined) {
        if (date === 0) {
          date = 7;
        }
        date = moment(this.numdateWeekStr)
          .add(date - 1, "days")
          .format("YYYY-MM-DD");
      }
      this.dialogVisibleDay = true;
      this.judeg(obj);
      this.MonthObj = obj;
      let nowDate = moment().format("YYYY-MM-DD");
      if (date === nowDate) {
        let str = this.weekText(date, 1);
        let str1 = moment(date).format("M月");
        let str2 = moment(date).format("D");
        this.MonthObj.str = str;
        this.MonthObj.str1 = str1;
        this.MonthObj.str2 = str2;
      } else {
        this.MonthObj.date = moment(date).format("M月D日") + this.weekText(date, 1);
      }
    },
    async getPlanCompleteByWeek(type) {
      try {
        let data = {};

        data.startDate = this.dateConst;
        data.endDate = this.dateConstSunday;

        data.tenant_id = this.$store.getters.getUser.tenant_id;
        data.user_id = this.$store.getters.getUser.user_id;
        data.date = moment(this.calendarDate).format("YYYY-MM-DD");
        data.date = this.dateConst;
        if (this.$store.getters.getUser.role == "staff") {
          data.owner_id = this.selectPeople;
        } else {
          data.owner_id = this.GLOBAL.selectPeople_global;
        }
        await http.post("/wapi/Calendar/getPlanCompleteByWeek", data).then((res) => {
          let weekPlan = res.data.array;

          if (res.data.completion >= 0) {
            this.completeDegree = res.data.completion + "%";
          }
          if (res.data.array.length === 0) {
            this.completeDegree = "N/A";
          }
          //处理获取周计划数据
          this.weekJudeg(weekPlan);
        });
      } catch (e) {}
    },

    async getCalendarInstantData(api, params = {}, fileName) {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let user = this.$store.getters.getUser;
      // if (this.GLOBAL.date) {
      //   debugger
      //   params.month = moment().format("YYYY-MM");
      // } else {
      //   params.month = "";
      // }

      debugger;
      let data = {};
      data.startDate = moment().format("YYYY-MM-01");
      data.endDate = moment().format("YYYY-MM-31");
      data.tenant_id = this.$store.getters.getUser.tenant_id;
      data.user_id = this.$store.getters.getUser.user_id;
      data.date = moment(this.calendarDate).format("YYYY-MM-DD");
      data.date = this.dateConst;
      data.month = moment().format("YYYY-MM");
      data.territory = this.GLOBAL.territory_id;
      debugger;
      if (this.$store.getters.getUser.role == "staff") {
        data.owner_id = this.selectPeople;
      } else {
        data.owner_id = this.GLOBAL.selectPeople_global;
      }
      await axios({
        method: "post",
        url: "/wapi/derive/exportCalendarInstantData",
        data: data,
        responseType: "arraybuffer",
        // responseType: "blob",
      })
        .then((res) => {
          // let uInt8Array = new Uint8Array(res.data); //先将返回的二进制数组转化为js的二进制数组
          // if (res.status !== 200) {
          //   loading.close();
          //   this.$message.error("下载失败");
          //   return;
          // }
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
          const elink = document.createElement("a");
          elink.download = fileName + params.month + ".xlsx";
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          loading.close();
        })
        .catch((e) => {
          loading.close();
          this.$message.error("下载失败");
        });
    },

    async getCalendarInstantData2(type) {
      try {
        let data = {};
        data.startDate = moment().format("YYYY-MM-01");
        data.endDate = moment().format("YYYY-MM-31");
        data.tenant_id = this.$store.getters.getUser.tenant_id;
        data.user_id = this.$store.getters.getUser.user_id;
        data.date = moment(this.calendarDate).format("YYYY-MM-DD");
        data.date = this.dateConst;
        if (this.$store.getters.getUser.role == "staff") {
          data.owner_id = this.selectPeople;
        } else {
          data.owner_id = this.GLOBAL.selectPeople_global;
        }
        debugger;
        await http.post("/wapi/derive/exportCalendarInstantData", data).then((res) => {
          debugger;
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
          const elink = document.createElement("a");
          elink.download = fileName + params.month + ".xlsx";
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          loading.close();
        });
      } catch (e) {}
    },
    weekJudeg(arr) {
      // console.log(arr)
      let array = JSON.parse(JSON.stringify(arr));

      for (let i = 0; i < array.length; i++) {
        let obj = array[i];
        switch (obj.category) {
          case "INSTITUTION_VISIT":
            obj.icon = medicalvisit;
            obj.text = "医务拜访";
            break;
          case "MEETING":
            obj.icon = activity;
            obj.text = "会议活动";
            obj.title = obj.value1;
            break;
          case "STORE_INSPECTION":
            obj.icon = store;
            obj.text = "门店巡查";
            break;
          case "DISTRIBUTOR_VISIT":
            obj.icon = distributor;
            obj.text = "商务拜访";
            break;
          // obj.title =
          case "HCP_CALL":
            obj.icon = medicalvisit;
            obj.text = "医务拜访";
            obj.title = obj.title + "-" + obj.dept_name + "-" + obj.hcp_name;
            break;
        }

        if (obj.completed !== "T") {
          obj.check = redCheck;
          obj.status = "尚未完成";
        } else {
          if (obj.activity_date) {
            obj.status = "完成日期:" + moment(obj.activity_date).format("YYYY-MM-DD");
            obj.check = greenCheck;
          }
        }
      }

      let Medical = [];
      let Business = [];
      let event = [];
      let Store = [];
      for (let i = 0; i < array.length; i++) {
        if (array[i].category === "INSTITUTION_VISIT" || array[i].category === "HCP_CALL") {
          Medical.push(array[i]);
        } else if (array[i].category === "DISTRIBUTOR_VISIT") {
          Business.push(array[i]);
        } else if (array[i].category === "MEETING") {
          event.push(array[i]);
        } else if (array[i].category === "STORE_INSPECTION") {
          Store.push(array[i]);
        }
      }
      this.modelWeekPlan = Medical.concat(Store)
        .concat(event)
        .concat(Business);
    },
    openModel() {
      if (this.modelWeekPlan.length > 0) {
        this.dialogVisible = true;
      } else {
        this.dialogVisible = false;
      }
    },
    weekLiMarginLeft() {
      if (this.weekLiMargin_Left === false) {
        //点击查看周日
        this.weekLiMargin_text_left = "返回";
        this.marginValue = 20 + "%";
        this.weekLiMargin_Left = true;
        this.left_png = right_png;
      } else {
        this.weekLiMargin_text_left = "查看周日";
        this.marginValue = 0 + "%";
        this.weekLiMargin_Left = false;
        this.left_png = left_png;
      }
      this.onoffLi = false; //控制有无边框样式
    },
    weekLiMarginRight() {
      if (this.weekLiMargin_Right === false) {
        this.weekLiMargin_text_right = "返回";
        this.marginValue = -20 + "%";
        this.weekLiMargin_Right = true;
        this.right_png = left_png;
      } else {
        this.weekLiMargin_text_right = "查看周六";
        this.marginValue = 0 + "%";
        this.weekLiMargin_Right = false;
        this.right_png = right_png;
      }
      this.onoffLi = true; //控制有无边框样式
    },
    onoffTotalColor() {
      if (this.thisDate === moment(new Date()).format("YYYY-MM-DD")) {
        return true;
      } else {
        return false;
      }
    },
    getlclickInfoRouter(row, obj) {
      row.titleName = this.titleName;
      if (row.category === "MEETING") {
        this.$router.push({ name: "meetInfo", params: row });
      } else if (row.category === "TRAVEL") {
        this.$router.push({ name: "travel", params: row });
      } else if (row.category === "HCP_CALL") {
        this.$router.push({ name: "dropDetails", params: row });
      } else if (row.category === "INTERNAL") {
        if (row.type === "LEAVE_TYPE") {
          this.$router.push({ name: "holiday", params: row });
        } else if (row.type === "TRAINING") {
          this.$router.push({ name: "train", params: row });
        } else if (row.type === "PAPERWORK") {
          this.$router.push({ name: "syndicate", params: row });
        }
      } else if (row.category === "COACHING") {
        this.$router.push({ name: "assist", params: row });
      } else if (row.category === "DISTRIBUTOR") {
        this.$router.push({ name: "businessDetails", params: row });
      } else if (row.category === "LEAVE_TYPE") {
        this.$router.push({ name: "holiday", params: row });
      } else if (row.category === "STORE_INSPECTION") {
        this.$router.push({ name: "storeTourInfo", params: row });
      }
    },
    isShowWeekPlan() {
      if (this.title === "管理员") {
        if (this.GLOBAL.selectPeople_global !== "" && this.GLOBAL.selectPeople_global !== "0" && this.GLOBAL.selectOu_global === "") {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    itemColor(item) {
      if (item.category === "COACHING") {
        return "#409EFF";
      } else {
        return "#bbbbbb";
      }
    },
    funDis(item) {
      if (item.disList && item.disList.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    handleClose() {},
  },
};
</script>
<style lang="scss" module>
.month {
  margin-bottom: 15px;
}
</style>
<style>
#calendar .el-tabs__nav-scroll {
  position: relative;
  height: 50px;
}
#calendar .el-tabs__nav {
  display: block;
  position: absolute;
  border: 1px solid transparent;
  left: 50%;
  margin-left: -174px;
}
#calendar .el-tabs__header {
  border-bottom: none;
}
#calendar .el-tabs__item {
  border: 1px solid #dcdfe6;
  padding-left: 50px;
  padding-right: 50px;
  font-size: 18px;
}
#calendar .is-active {
  color: #409eff;
  border: 1px solid #c6e2ff;
  background-color: #ecf5ff;
}
#calendar .el-tabs__item:first-child {
  border-radius: 4px 0 0 4px;
}
.amap-lib-marker-mid {
  display: none;
}
.amap-lib-marker-from {
  display: none;
}
.amap-lib-marker-to {
  display: none;
}
#calendar .el-tabs__item:nth-of-type(2) {
  border-left: none;
  border-right: none;
}
#calendar .el-tabs__item:last-child {
  border-radius: 0px 4px 4px 0px;
}
#calendar td {
  border: none;
}
#calendar .el-calendar-table .el-calendar-day {
  text-align: center;
  height: 40px;
}
#calendar .el-calendar {
  border: 1px solid #dcdfe6;
}
#calendar .el-calendar__header {
  padding-bottom: 0;
  border-bottom: none;
}
#calendar_body_row_p .el-tabs__content {
  height: calc(100% - 65px);
}
#calendar #calendar_body_row_p p {
  margin-top: 12px;
  margin-bottom: 12px;
}
#calendar .el-button.el-button--plain.el-button--mini {
  padding: 4px 5px;
  font-size: 12px;
}
#calendar .el-calendar__title {
  font-weight: bold;
}
#calendar h4 {
  border-bottom: none;
  margin-bottom: 0;
}
#calendar_weekPlanInfo_dialog .el-dialog__body {
  padding: 15px 20px 20px;
}
</style>
<style rel="stylesheet/scss" scoped lang="scss">
#calendar #calendarColDay:hover {
  cursor: pointer;
}
#calendar .calendar {
  width: 100%;
  margin: 0px 0px 20px 0px;
  color: #555;
  position: relative;
}

#calendar .calendar h4 {
  line-height: 40px;
  background-color: #fff;
  text-align: center;
  color: #333;
  box-shadow: 0 0 4px #bbb;
  -webkit-box-shadow: 0 0 4px #bbb;
}

#calendar .calendar button {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 5px;
  color: #777;
  background: #f3f3f3;
  border: none;
}

#calendar .calendar button:focus {
  border: none;
  outline: none;
}

#calendar .calendar button.month-less {
  left: 10px;
}

#calendar .calendar button.month-add {
  right: 10px;
}

#calendar .calendar .sign_tab {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e8e8e8;
  border-top: 0;
  table-layout: fixed;
}

#calendar .calendar .sign_tab th {
  text-align: center;
  height: 14.28571428571429vw;
  font-weight: 700;
}

#calendar .calendar .sign_tab td {
  position: relative;
  border: 1px solid #eee;
  padding: 15px 0;
  text-align: center;
  font-size: 14px;
  font-family: arial;
}

#calendar .calendar .sign_tab td.over {
  background-color: #fff;
  border-left: 0;
  border-right: 0;
}

#calendar .calendar .sign_tab td.disa {
  color: #ccc;
  background: none;
  height: 50px;
  * {
    color: #ccc;
    right: 10px;
    top: 10px;
  }
}
#calendar .calendar .styleNowDate {
  display: inline-block;
  padding: 5px;
  border-radius: 50%;
  background: red;
  color: white;
}

#calendar .calendar .sign_tab td.other {
  height: 50px;
  cursor: pointer;
  color: #646464;
}

#calendar .calendar .sign_tab td.check_day {
  background-color: #f8f8f8;
  color: #58ce7a;
  position: relative;
}

#calendar .calendar {
  .ui-state-down,
  .ui-state-default {
    font-size: 10px;
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 3px;
    left: 0;
  }
  .ui-state-down {
    color: #f60;
  }
}

#calendar .calendar .ui-state-up {
  font-size: 10px;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 3px;
  left: 0;
}

#calendar .calendar .sign_tab td.cur_day {
  background-color: #ffd2d2;
  color: #fff;
}

#calendar .checkin-btn {
  display: block;
  width: 90%;
  margin: 0 auto;
  text-align: center;
  font-size: 10px;
}
#calendar .weekLi {
  border: 1px solid #dcdfe6;
}
#calendar .weekLi:first-child {
  position: absolute;
  left: -20%;
  border-right: none;
}
#calendar .weekLi:nth-child(2) {
  position: absolute;
  left: 0%;
  border-right: none;
}
#calendar .weekLi:nth-child(3) {
  position: absolute;
  left: 20%;
  border-right: none;
}
#calendar .weekLi:nth-child(4) {
  position: absolute;
  left: 40%;
  border-right: none;
}
#calendar .weekLi:nth-child(5) {
  position: absolute;
  left: 60%;
}
#calendar .weekLi:nth-child(6) {
  position: absolute;
  left: 80%;
}
#calendar .weekLi:nth-child(7) {
  position: absolute;
  left: 100%;
  border-right: 1px solid #dcdfe6 !important;
}
#calendar ul li.border-right {
  border-right: none;
}
#calendar ul li.border {
  border-right: none;
}
#calendar ul.ulScoller {
  left: 0;
}
#calendar ul.weekLiLeft {
  left: 20%;
}

#calendar ul.weekLiRight {
  left: -20%;
}
</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/calendar.vue